<template>
    <div class="main-wrapper scroll-y custom-scrollbar with-tabs view-user">

        <card-user-profile></card-user-profile>

        <ion-list>
            <div v-for="(item,index) in navigation" :key="item.route" style="background: #f2f2f2">
                <item-menu
                        :index="index+1"
                        :title="item.title"
                        :route="item.route"
                        :icon="item.icon"
                        :content="item.content"
                        :disabled="item.disabled"
                        :slug="item.slug">
                </item-menu>
            </div>
        </ion-list>

    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import ItemMenu from '@/items/ItemMenu';
    import CardUserProfile from '@/cards/CardUserProfile';

    export default {
        name: 'UserIndex',
        components: { ItemMenu, CardUserProfile },
        computed: {
            ...mapState({
                navigation: state => state.config.navigation ? state.config.navigation.profile : [],
            })
        }
    }
</script>

<style lang="scss" scoped>
    ion-list{
        padding: 0;
    }
    ion-item{
        --background: #f2f2f2;
    }
</style>